// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4t3i1i94{height:396px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/smart-card/dist/esm/view/RelatedLinksModal/components/RelatedLinksBaseModal.compiled.css"],"names":[],"mappings":"AAAA,WAAW,YAAY","sourcesContent":["._4t3i1i94{height:396px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
